export default {
  ECOMMERCE_PERSONALIZED_PAYMENTS: 'e-commerce/personalized-payments',
  ECOMMERCE_PERSONALIZED_PAYMENTS_CONTACT_FORM: 'e-commerce/personalized-payments/contact-form',
  ECOMMERCE_CREDIT: 'e-commerce/credit',
  ECOMMERCE_TRADE: 'e-commerce/trade-in',
  ECOMMERCE_MAKE_AN_OFFER_SUB_FLOW: 'e-commerce/make-an-offer-sub-flow',
  ECOMMERCE_FINANCE: 'e-commerce/finance',
  TRADE: 'trade-in/value-request',
  CREDIT: 'credit/credit-request',
  FINANCE: 'credit/finance-application',
  TEST_DRIVE: 'test-drive/test-drive-request',
  INSURANCE: 'insurance/insurance-request',
};
